import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { Level } from "../models/level.model";
import { LevelFilter } from "../models/levelFilter.model";
import { LevelHistoric } from "../models/levelHistoric.model";
import { LevelType } from "../models/levelType.model";

@Injectable({
  providedIn: "root"
})
export class CommercialStructureService {
  private API_LEVELS_URL = `${environment.API_URL}api/leveltype`;
  private API_CAMPAIGN_LEVELS_URL = `${environment.API_URL}api/campaignlevels`;
  private API_HISTORIC_CAMPAIGN_LEVELS_URL = `${environment.API_URL}api/campaignlevels/historic`;

  private API_CAMPAIGN_LEVELS_FIND_URL = `${environment.API_URL}api/campaignlevels/find`;
  private API_CAMPAIGN_LEVELS_CLONE_URL = `${environment.API_URL}api/campaignlevels/clone`;
  private API_RESELLERS_BY_USER = `${environment.API_URL}api/users`;
  private API_REASSIGN_RESELLERS = `${environment.API_URL}api/campaignlevels/reassign`;
  private API_ASSIGN_RESELLERS = `${environment.API_URL}api/campaignlevels/assign`;
  private API_ZONES_USER = `${environment.API_URL}api/campaignlevels/zones`;
  private API_AREAS_ZONE = `${environment.API_URL}api/campaignlevels/areas`;
  private API_CURRENT_CAMPAIGN_LEVELS = `${environment.API_URL}api/campaign/current/levels`;

  constructor(private http: HttpClient) {}

  getLevels(): Observable<LevelType[]> {
    return this.http.get<LevelType[]>(this.API_LEVELS_URL);
  }

  getStructureByLevelAndCampaign(levelTypeId, campaignId): Observable<Level[]> {
    let httpParams = new HttpParams();

    httpParams = httpParams.append("levelTypeId", levelTypeId);
    if (campaignId) {
      httpParams = httpParams.append("campaignId", campaignId);
    }

    return this.http.get<Level[]>(this.API_CAMPAIGN_LEVELS_URL, {
      params: httpParams
    });
  }


  getStructureHistoricByLevel(levelId): Observable<LevelHistoric[]> {
    let httpParams = new HttpParams();
    httpParams = httpParams.append("levelId", levelId);
    return this.http.get<LevelHistoric[]>(this.API_HISTORIC_CAMPAIGN_LEVELS_URL, {
      params: httpParams
    });
  }

  getLevelsByParentId(parentId): Observable<LevelFilter> {
    const request = {
      filter: {
        parentId
      },
      pageNumber: 1,
      pageSize: 100
    };

    return this.http.post<LevelFilter>(this.API_CAMPAIGN_LEVELS_FIND_URL, request);
  }

  deleteLevel(id): Observable<any> {
    const userToken = localStorage.getItem(environment.authTokenKey);
    let httpHeaders = new HttpHeaders();
    httpHeaders = httpHeaders.append("Authorization", `Bearer ${userToken}`);
    httpHeaders.set("Content-Type", "application/json");

    return this.http.delete(`${this.API_CAMPAIGN_LEVELS_URL}/${id}`, {
      headers: httpHeaders
    });
  }

  copyStructurePreviusCampaign(id) {
    const userToken = localStorage.getItem(environment.authTokenKey);
    let httpHeaders = new HttpHeaders();
    httpHeaders = httpHeaders.append("Authorization", `Bearer ${userToken}`);
    httpHeaders.set("Content-Type", "application/json");

    return this.http.post(this.API_CAMPAIGN_LEVELS_CLONE_URL, { toCampaignId: id }, { headers: httpHeaders });
  }

  saveStructure(request): Observable<any> {
    const userToken = localStorage.getItem(environment.authTokenKey);
    let httpHeaders = new HttpHeaders();
    httpHeaders = httpHeaders.append("Authorization", `Bearer ${userToken}`);
    httpHeaders.set("Content-Type", "application/json");

    return this.http.post(this.API_CAMPAIGN_LEVELS_URL, request, {
      headers: httpHeaders
    });
  }

  updateStructure(request, id) {
    const userToken = localStorage.getItem(environment.authTokenKey);
    let httpHeaders = new HttpHeaders();
    httpHeaders = httpHeaders.append("Authorization", `Bearer ${userToken}`);
    httpHeaders.set("Content-Type", "application/json");

    return this.http.put(`${this.API_CAMPAIGN_LEVELS_URL}/${id}`, request, {
      headers: httpHeaders
    });
  }

  getResellersByUser(campaignId: number, levelId: number) {
    return this.http.get(`${this.API_RESELLERS_BY_USER}?campaignId=${campaignId}&levelId=${levelId}`);
  }

  getZonesByUser() {
    return this.http.get<any>(`${this.API_ZONES_USER}`);
  }

  getAreas(campaignId: number, zoneId: number) {
    return this.http.get<any>(`${this.API_AREAS_ZONE}/${campaignId}/${zoneId}`);
  }

  areasByZoneInActiveCampaign(zoneId: number): Observable<string[]> {
	return this.http.get<any>(`${this.API_CAMPAIGN_LEVELS_URL}/activeAreas/${zoneId}`);
  }

  getAreasByZone(zoneId: number) {
    return this.http.get<any>(`${this.API_AREAS_ZONE}/${zoneId}`);
  }

  getChildrenLevels(levelId: number): Observable<Level[]> {
    return this.http.get<Level[]>(`${this.API_CURRENT_CAMPAIGN_LEVELS}/${levelId}`);
  }

  getLevelForCurrentUser(): Observable<Level> {
    return this.http.get<Level>(`${environment.API_URL}users/current/levels`);
  }

  assignLeader(request: any) {
    return this.http.post(this.API_ASSIGN_RESELLERS, request);
  }

  migrateLeader(request: any) {
    return this.http.post(this.API_REASSIGN_RESELLERS, request);
  }
}
